import { render, staticRenderFns } from "./controler.vue?vue&type=template&id=128101e0&scoped=true"
import script from "./controler.vue?vue&type=script&lang=js"
export * from "./controler.vue?vue&type=script&lang=js"
import style0 from "./controler.vue?vue&type=style&index=0&id=128101e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128101e0",
  null
  
)

export default component.exports